import React, { ReactNode, useEffect } from 'react'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { useMediaQuery, useTheme } from '@mui/material'
import { AttachMoney, Info } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import { UserRoles } from 'shared/consts'
import useLogin from 'shared/store/useLogin'
import NonRefundableIcon from 'assets/images/no-return.webp'

type RenderIconType = {
   condition: boolean
   renderNode: () => ReactNode
}[]
interface Props {
   row: CooperatingWholesaler
}

export default function SalerLogo({ row }: Props) {
   const { user } = useLogin()
   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
   const { t } = useTranslation('TRANSLATION')

   const iconsToRender: RenderIconType = [
      {
         condition: !!row.netPrice && !!row.wholesaleMessage,
         renderNode: () => (
            <Tooltip title={row.wholesaleMessage}>
               <Info sx={{ '&:hover': { cursor: 'pointer' } }} color="primary" />
            </Tooltip>
         ),
      },
      {
         condition: !!row.requirePrepayment,
         renderNode: () => (
            <Tooltip title={t('TRANSLATION:requirePrepayment')}>
               <AttachMoney color="success" />
            </Tooltip>
         ),
      },
      {
         condition: !!row.wholesaleParams && !!row.wholesaleParams.nonRefundable,
         renderNode: () => (
            <Tooltip title={t('TRANSLATION:nonRefundable')}>
               <img height="25px" width="auto" src={NonRefundableIcon} alt="non-refundable-icon" />
            </Tooltip>
         ),
      },
   ]

   function renderIcons() {
      return iconsToRender.map((icon) => (icon.condition ? icon.renderNode() : null))
   }

   // eslint-disable-next-line @typescript-eslint/no-empty-function
   useEffect(() => {}, [user.roles])

   // eslint-disable-next-line no-nested-ternary
   return row.wholesaleName ? (
      user?.roles.includes(UserRoles.SALES_REP) ? (
         <span>{row.wholesaleName}</span>
      ) : (
         <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
               style={{ verticalAlign: 'middle', height: isMobile ? 15 : 20, width: 'auto' }}
               src={`https://files.motorro.eu/img/logos-wholesalers/light/${row.wholesaleUuid}.png`}
               alt={row.wholesaleName}
            />
            <Box sx={{ ml: 1, display: 'flex', gap: 0.5, justifyContent: 'center' }}>
               {renderIcons()}
               {/* {row.netPrice && row.wholesaleMessage && (
                  <Tooltip title={row.wholesaleMessage}>
                     <Info sx={{ '&:hover': { cursor: 'pointer' } }} color="primary" />
                  </Tooltip>
               )}
               {row.requirePrepayment && (
                  <Tooltip title={t('TRANSLATION:requirePrepayment')}>
                     <AttachMoney color="success" />
                  </Tooltip>
               )}
               {!row.wholesaleParams && (
                  <Tooltip title={t('TRANSLATION:nonRefundable')}>
                     <img height="25px" width="auto" src={NonRefundableIcon} alt="non-refundable-icon" />
                  </Tooltip>
               )} */}
            </Box>
         </Box>
      )
   ) : (
      <p>No Logo</p>
   )
}
